import React, { useEffect } from 'react'
import tw from 'twin.macro'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import { FormikRadioGroup } from 'src/components/shared/form/formik/FormikRadioGroup'
import { BankPaymentAccountType } from './BankPaymentForm.constants'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { getPartner } from 'src/selectors/user'
import { useFormikContext } from 'formik'
import { BankPaymentFormValues } from './BankPaymentForm.interface'
import { colors } from 'src/theme'
import { CustomerPaymentMethod } from 'src/interfaces/customer'

interface BankInformationContentProps {
  handleChange: (e: React.ChangeEvent<any>) => void
  showCurrentPaymentMethod?: boolean
  currentPaymentMethod?: CustomerPaymentMethod | null
}

const ACCOUNT_NUMBER_MASK = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]

const paymentAccountOptions = [
  { label: 'Checking', value: BankPaymentAccountType.CHECKING },
  { label: 'Savings', value: BankPaymentAccountType.SAVINGS },
]

export const BankInformationContent = ({ handleChange }: BankInformationContentProps) => {
  const customer = useSelector(getPartner)
  const { values, setFieldValue } = useFormikContext<BankPaymentFormValues>()

  const hasPrefilledName = !!values.nameOnCard

  useEffect(() => {
    if (customer && !values.nameOnCard) {
      setFieldValue('nameOnCard', customer.displayName)
    }
  }, [customer, setFieldValue, values.nameOnCard])

  return (
    <>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="nameOnCard"
          placeholder="Enter name on account"
          label="Business name"
          onChange={handleChange}
          disabled={hasPrefilledName}
          css={tw`w-full`}
        />
        {hasPrefilledName && (
          <div
            css={tw`mt-2 p-3 flex flex-row items-center rounded-2xl`}
            style={{ backgroundColor: colors.SHADES_GREY_100 }}
          >
            <div
              css={tw`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mr-3`}
              style={{ backgroundColor: colors.SHADES_GREY_600 }}
            >
              <Typography css={tw`text-white text-xs font-bold`}>i</Typography>
            </div>
            <div css={tw`flex flex-col`}>
              <Typography
                css={tw`text-sm`}
                style={{ color: colors.SHADES_GREY_600, fontSize: '14px' }}
              >
                Business name is prefilled from your verified entity and can't be changed. Contact
                support if you need help.
              </Typography>
            </div>
          </div>
        )}
      </div>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="routingNumber"
          placeholder="Enter routing number"
          label="Routing number"
          onChange={handleChange}
          css={tw`w-full`}
        />
      </div>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="accountNumber"
          placeholder="Enter account number"
          label="Account number"
          mask={ACCOUNT_NUMBER_MASK}
          onChange={handleChange}
          css={tw`w-full`}
        />
      </div>
      <div css={tw`mb-4`}>
        <FormikRadioGroup
          label="Select account type"
          name="accountType"
          options={paymentAccountOptions}
          onChange={handleChange}
        />
      </div>
    </>
  )
}
